// MarkdownContent (react-markdown 8) filtra las URIs de imagen con su
// `uriTransformer`, que solo admite http/https/mailto/tel: una imagen `data:`
// acabaría como `javascript:void(0)`. El backend (remote-docs) entrega las
// imágenes del repo privado inlineadas como data:, así que las dejamos pasar
// —solo base64 y solo tipos de imagen— y para el resto reproducimos la regla
// por defecto (sin protocolo o http/https → tal cual; cualquier otro → vacío).
const DATA_IMAGE = /^data:image\/(png|jpeg|gif|webp|svg\+xml);base64,[a-z0-9+/=]+$/i;
const SAFE_PROTOCOL = /^(https?:|mailto:|tel:)/i;

export function transformImageUri(uri: string): string {
  const value = (uri ?? '').trim();
  if (DATA_IMAGE.test(value)) return value;
  if (!value.includes(':') || value.startsWith('/') || value.startsWith('#')) return value;
  return SAFE_PROTOCOL.test(value) ? value : '';
}
